<template>
  <PdvPlpExternalRegister ref="registerExternal" :customer="customer" />
</template>

<script>
import PdvPlpExternalRegister from "./external/PdvPlpExternalRegister.vue";
export default {
  name: "PdvCallExternal",
  props: ['customer'],
  components: {
    PdvPlpExternalRegister
  },
  computed: {
    ruleForm() {
      const vm = this;
      return vm.$refs.registerExternal.ruleForm;
    },
  },
  methods: {
    startup(form) {
      this.$refs.registerExternal.startup(form);
    },
    clear() {
      this.$refs.registerExternal.clear();
    },
    hotkey(key) {
      this.$refs.registerExternal.hotkey(key);
    },
    focus() {
      this.$refs.registerExternal.focus();
    },
  }
}
</script>